import React from 'react'
import { useLocation } from 'react-router-dom'
import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react'
import routesBack from '../../../routesBack'

const BackBreadcrumb = () => {
  const currentLocation = useLocation().pathname

  const getRouteName = (pathname) => {
    const currentRoute = routesBack.find(route => `/dashboard/${route.path}` === pathname)
    return currentRoute ? currentRoute.name : false
  }

  const getBreadcrumbs = (location) => {
    const breadcrumbs = []
    location.split('/').reduce((prev, curr, index, array) => {
      const currentPathname = `${prev}/${curr}`
      const routeName = getRouteName(currentPathname)
      if (routeName) {
        breadcrumbs.push({
          pathname: currentPathname,
          name: routeName,
          active: index + 1 === array.length,
        })
      }
      return currentPathname
    })
    return breadcrumbs
  }

  const breadcrumbs = getBreadcrumbs(currentLocation)

  return (
      <CBreadcrumb className="my-0">
        <CBreadcrumbItem href="/">Home</CBreadcrumbItem>
        {breadcrumbs.map((breadcrumb, index) => (
            <CBreadcrumbItem
                key={index}
                {...(breadcrumb.active ? { active: true } : { href: breadcrumb.pathname })}
            >
              {breadcrumb.name}
            </CBreadcrumbItem>
        ))}
      </CBreadcrumb>
  )
}

export default React.memo(BackBreadcrumb)
